<template>
  <div>
    <!-- <div class="nav-item">
      <ul>
        <li v-for="(item,index) in nav" :key="index">
          <a href="#">{{item}}</a>
        </li>
      </ul>
    </div>-->
    <div class="nav-body">
      <!-- 侧边导航 -->
      <div class="nav-side" ref="navSide">
        <ul>
          <li @mouseenter="showDetail(1)" @mouseleave="hideDetail(1)">
            <span class="nav-side-item">电脑、办公设备</span>
          </li>
          <li @mouseenter="showDetail(2)" @mouseleave="hideDetail(2)">
            <span class="nav-side-item">网络产品</span>
          </li>
          <li @mouseenter="showDetail(3)" @mouseleave="hideDetail(3)">
            <span class="nav-side-item">数码家电</span>
          </li>
          <li @mouseenter="showDetail(4)" @mouseleave="hideDetail(4)">
            <span class="nav-side-item">文化用品</span>
          </li>
          <li @mouseenter="showDetail(5)" @mouseleave="hideDetail(5)">
            <span class="nav-side-item">体育用品</span>
          </li>
          <li @mouseenter="showDetail(6)" @mouseleave="hideDetail(6)">
            <span class="nav-side-item">日用商品</span>
          </li>
          <li @mouseenter="showDetail(7)" @mouseleave="hideDetail(7)">
            <span class="nav-side-item">食品类</span>
          </li>
        </ul>
      </div>
      <div class="nav-content">
        <!-- 幻灯片 -->
        <div>
          <Carousel autoplay loop>
            <CarouselItem v-for="(item, index) in marketing.CarouselItems" :key="index">
              <router-link :to='"/goodsList?sreachData="+item.name'>
                <img :src="item.url" />
              </router-link>
            </CarouselItem>
          </Carousel>
        </div>
        <div class="nav-show">
          <div class="nav-show-img" v-for="(item, index) in marketing.activity" :key="index">
            <router-link to="/goodsList">
              <img :src="item" />
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div
        class="detail-item-panel panel-1"
        :duration="{ enter: 100, leave: 100 }"
        v-show="panel1"
        @mouseenter="showDetail(1)"
        ref="itemPanel1"
        @mouseleave="hideDetail(1)"
      >
        <ul>
          <li v-for="(items, index) in panelData1.classNav" :key="index" class="detail-item-row">
            <span class="detail-item-title">
              {{items.title}}
              <span class="glyphicon glyphicon-menu-right"></span>
            </span>
            <router-link
              :to="'/goodsList?sreachData='+item"
              v-for="(item, subIndex) in items.tags"
              :key="subIndex"
            >
              <span class="detail-item">{{item}}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </transition>
    <transition name="fade">
      <div
        class="detail-item-panel panel-2"
        :duration="{ enter: 100, leave: 100 }"
        v-show="panel2"
        @mouseenter="showDetail(2)"
        ref="itemPanel2"
        @mouseleave="hideDetail(2)"
      >
        <ul>
          <li v-for="(items, index) in panelData2.classNav" :key="index" class="detail-item-row">
            <span class="detail-item-title">
              {{items.title}}
              <span class="glyphicon glyphicon-menu-right"></span>
            </span>
            <router-link :to="'/goodsList?sreachData='+item" v-for="(item, subIndex) in items.tags" :key="subIndex">
              <span class="detail-item">{{item}}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </transition>
    <transition name="fade">
      <div
        class="detail-item-panel panel-3"
        :duration="{ enter: 100, leave: 100 }"
        v-show="panel3"
        @mouseenter="showDetail(3)"
        ref="itemPanel3"
        @mouseleave="hideDetail(3)"
      >
        <ul>
          <li v-for="(items, index) in panelData3.classNav" :key="index" class="detail-item-row">
            <span class="detail-item-title">
              {{items.title}}
              <span class="glyphicon glyphicon-menu-right"></span>
            </span>
            <router-link :to="'/goodsList?sreachData='+item" v-for="(item, subIndex) in items.tags" :key="subIndex">
              <span class="detail-item">{{item}}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </transition>
    <transition name="fade">
      <div
        class="detail-item-panel panel-4"
        :duration="{ enter: 100, leave: 100 }"
        v-show="panel4"
        @mouseenter="showDetail(4)"
        ref="itemPanel4"
        @mouseleave="hideDetail(4)"
      >
        <ul>
          <li v-for="(items, index) in panelData4.classNav" :key="index" class="detail-item-row">
            <span class="detail-item-title">
              {{items.title}}
              <span class="glyphicon glyphicon-menu-right"></span>
            </span>
            <router-link :to="'/goodsList?sreachData='+item" v-for="(item, subIndex) in items.tags" :key="subIndex">
              <span class="detail-item">{{item}}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </transition>
    <transition name="fade">
      <div
        class="detail-item-panel panel-5"
        :duration="{ enter: 100, leave: 100 }"
        v-show="panel5"
        @mouseenter="showDetail(5)"
        ref="itemPanel5"
        @mouseleave="hideDetail(5)"
      >
        <ul>
          <li v-for="(items, index) in panelData5.classNav" :key="index" class="detail-item-row">
            <span class="detail-item-title">
              {{items.title}}
              <span class="glyphicon glyphicon-menu-right"></span>
            </span>
            <router-link :to="'/goodsList?sreachData='+item" v-for="(item, subIndex) in items.tags" :key="subIndex">
              <span class="detail-item">{{item}}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </transition>
    <transition name="fade">
      <div
        class="detail-item-panel panel-6"
        :duration="{ enter: 100, leave: 100 }"
        v-show="panel6"
        @mouseenter="showDetail(6)"
        ref="itemPanel6"
        @mouseleave="hideDetail(6)"
      >
        <ul>
          <li v-for="(items, index) in panelData6.classNav" :key="index" class="detail-item-row">
            <span class="detail-item-title">
              {{items.title}}
              <span class="glyphicon glyphicon-menu-right"></span>
            </span>
            <router-link :to="'/goodsList?sreachData='+item" v-for="(item, subIndex) in items.tags" :key="subIndex">
              <span class="detail-item">{{item}}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </transition>
    <transition name="fade">
      <div
        class="detail-item-panel panel-7"
        :duration="{ enter: 100, leave: 100 }"
        v-show="panel7"
        @mouseenter="showDetail(7)"
        ref="itemPanel7"
        @mouseleave="hideDetail(7)"
      >
        <ul>
          <li v-for="(items, index) in panelData7.classNav" :key="index" class="detail-item-row">
            <span class="detail-item-title">
              {{items.title}}
              <span class="glyphicon glyphicon-menu-right"></span>
            </span>
            <router-link :to="'/goodsList?sreachData='+item" v-for="(item, subIndex) in items.tags" :key="subIndex">
              <span class="detail-item">{{item}}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import store from "@/vuex/store";
import { mapState } from "vuex";
export default {
  name: "HomeNav",
  data() {
    return {
      panel1: false,
      panel2: false,
      panel3: false,
      panel4: false,
      panel5: false,
      panel6: false,
      panel7: false,
      nav: ["秒杀","优惠券","闪购","拍卖","服装城","超市","生鲜","全球购","金融"],
      panelData1: {
        classNav: [
          {
            title: "办公设备",
            tags: ["不间断电源", "传真机", "其它办公自动化设备", "复印机", "多功能一体机", "打印机", "扫描仪", "投影仪", "电话机", "碎纸机", "触控一体机", "速印机"]
          },
          {
            title: "电脑整机",
            tags: ["台式电脑", "学生用台式电脑", "平板式微型计算机", "笔记本电脑"]
          },
          {
            title: "电脑配件及外设产品",
            tags: ["U盘", "主机", "内存", "刻录机", "摄像头", "显示器", "电池", "硬盘", "移动硬盘", "键盘", "鼠标"]          },
          {
            title: "设备耗材",
            tags: ["墨盒、墨水","硒鼓、碳粉","碳带、色带、色带架"]
          }
        ]
      },
      panelData2: {
        classNav: [
          {
            title: "网络设备",
            tags: ["交换机", "路由器", "服务器", "防火墙"]
          }
        ]
      },
      panelData3: {
        classNav: [
          {
            title: "厨房电器",
            tags: ["电饭煲","电压力锅","电水壶、热水瓶","微波炉","电磁炉","咖啡机"]
          },
          {
            title: "大家电",
            tags: ["电视机","空调","冰箱、冷柜","洗衣机","热水器","烟机、灶具","消毒柜、洗碗机","迷你音响","DVD播放机"]
          },
          {
            title: "数码影像",
            tags: ["便携相机", "单电相机", "单反相机", "数码录像机"]
          },
          {
            title: "生活电器",
            tags: ["电风扇", "净化器", "空调扇", "饮水机", "加湿器", "吸尘器", "电器配件"]
          },
        ]
      },
      panelData4: {
        classNav: [
          {
            title: "办公用纸",
            tags: ["复印纸", "打印纸", "传真纸", "记事本薄", "易事贴、便签、标签"]
          },
          {
            title: "文件管理",
            tags: ["文件夹、袋","档案袋、盒","文件栏、盘、柜","板夹、报告夹、票夹","资料、名片册","报纸、杂志架"]
          },
          {
            title: "书写文具",
            tags: ["笔类", "笔芯", "墨水"]
          },
          {
            title: "服装",
            tags: []
          },
          {
            title: "桌面用品",
            tags: ["订书机","打孔机","起订机","笔筒","笔刨","树立","剪、刀、尺","针、钉、夹","涂改修正类","胶带、胶水类","计算器"]
          },
          {
            title: "财务行政用品",
            tags: ["号码机","印章","印台、印油、印泥","账本、单据、凭证","点钞、验钞机"]
          },
          {
            title: "其他",
            tags: ["保险柜", "白板", "电池", "插座"]
          }
        ]
      },
      panelData5: {
        classNav: [
          {
            title: "田径类器材",
            tags: ["跳高架", "秒表", "起跑器", "皮尺", "其他田径类器材"]
          },
          {
            title: "球类",
            tags: ["篮球","篮球架","足球","足球门","乒乓球台","排球","其他球类"]
          },
          {
            title: "健身器材",
            tags: ["单杠/双杠/高低杠","跳箱","平衡木","跑步机","健身车","其他体育及健身器材"]
          }
        ]
      },
      panelData6: {
        classNav: [
          {
            title: "日常用品",
            tags: ["饮用水","饮水机","茶具、杯具","纸巾","收纳用品","雨伞用具","碳净化"]
          },
          {
            title: "厨房用具",
            tags: ["厨具用品", "厨用小件"]
          },
          {
            title: "精美餐具",
            tags: ["筷勺/刀叉", "碗碟", "组合套装"]
          },
          {
            title: "清洁洗涤用品",
            tags: ["细节工具", "衣物清洁", "居室清洁", "厨卫清洁", "蛆虫消杀"]
          },
          {
            title: "家纺",
            tags: ["床品件套", "被子", "枕芯枕套", "蚊帐、凉席", "毛巾被、毯"]
          }
        ]
      },
      panelData7: {
        classNav: [
          {
            title: "其他食品",
            tags: []
          },
          {
            title: "包装食品类",
            tags: ["冲饮品","奶制品","粮油类"]
          },
          {
            title: "熟食品类",
            tags: []
          },
          {
            title: "生鲜食品类",
            tags: []
          }
        ]
      }
    };
  },
  computed: {
    ...mapState(["marketing"])
  },
  methods: {
    showDetail(index) {
      if (index === 1) this.panel1 = true;
      else if (index === 2) this.panel2 = true;
      else if (index === 3) this.panel3 = true;
      else if (index === 4) this.panel4 = true;
      else if (index === 5) this.panel5 = true;
      else if (index === 6) this.panel6 = true;
      else if (index === 7) this.panel7 = true;
    },
    hideDetail(index) {
      if (index === 1) this.panel1 = false;
      else if (index === 2) this.panel2 = false;
      else if (index === 3) this.panel3 = false;
      else if (index === 4) this.panel4 = false;
      else if (index === 5) this.panel5 = false;
      else if (index === 6) this.panel6 = false;
      else if (index === 7) this.panel7 = false;
    }
  },
  mounted() {
    this.$refs.itemPanel1.style.left =
      this.$refs.navSide.offsetLeft + this.$refs.navSide.offsetWidth + "px";
    this.$refs.itemPanel2.style.left =
      this.$refs.navSide.offsetLeft + this.$refs.navSide.offsetWidth + "px";
    this.$refs.itemPanel3.style.left =
      this.$refs.navSide.offsetLeft + this.$refs.navSide.offsetWidth + "px";
    this.$refs.itemPanel4.style.left =
      this.$refs.navSide.offsetLeft + this.$refs.navSide.offsetWidth + "px";
    this.$refs.itemPanel5.style.left =
      this.$refs.navSide.offsetLeft + this.$refs.navSide.offsetWidth + "px";
    this.$refs.itemPanel6.style.left =
      this.$refs.navSide.offsetLeft + this.$refs.navSide.offsetWidth + "px";
    this.$refs.itemPanel7.style.left =
      this.$refs.navSide.offsetLeft + this.$refs.navSide.offsetWidth + "px";
    this.$refs.itemPanel1.style.top = this.$refs.navSide.offsetTop + "px";
    this.$refs.itemPanel2.style.top = this.$refs.navSide.offsetTop + "px";
    this.$refs.itemPanel3.style.top = this.$refs.navSide.offsetTop + "px";
    this.$refs.itemPanel4.style.top = this.$refs.navSide.offsetTop + "px";
    this.$refs.itemPanel5.style.top = this.$refs.navSide.offsetTop + "px";
    this.$refs.itemPanel6.style.top = this.$refs.navSide.offsetTop + "px";
    this.$refs.itemPanel7.style.top = this.$refs.navSide.offsetTop + "px";
  },
  updated() {
    this.$refs.itemPanel1.style.left =
      this.$refs.navSide.offsetLeft + this.$refs.navSide.offsetWidth + "px";
    this.$refs.itemPanel2.style.left =
      this.$refs.navSide.offsetLeft + this.$refs.navSide.offsetWidth + "px";
    this.$refs.itemPanel3.style.left =
      this.$refs.navSide.offsetLeft + this.$refs.navSide.offsetWidth + "px";
    this.$refs.itemPanel4.style.left =
      this.$refs.navSide.offsetLeft + this.$refs.navSide.offsetWidth + "px";
    this.$refs.itemPanel5.style.left =
      this.$refs.navSide.offsetLeft + this.$refs.navSide.offsetWidth + "px";
    this.$refs.itemPanel6.style.left =
      this.$refs.navSide.offsetLeft + this.$refs.navSide.offsetWidth + "px";
    this.$refs.itemPanel7.style.left =
      this.$refs.navSide.offsetLeft + this.$refs.navSide.offsetWidth + "px";
    this.$refs.itemPanel1.style.top = this.$refs.navSide.offsetTop + "px";
    this.$refs.itemPanel2.style.top = this.$refs.navSide.offsetTop + "px";
    this.$refs.itemPanel3.style.top = this.$refs.navSide.offsetTop + "px";
    this.$refs.itemPanel4.style.top = this.$refs.navSide.offsetTop + "px";
    this.$refs.itemPanel5.style.top = this.$refs.navSide.offsetTop + "px";
    this.$refs.itemPanel6.style.top = this.$refs.navSide.offsetTop + "px";
    this.$refs.itemPanel7.style.top = this.$refs.navSide.offsetTop + "px";
  },
  store
};
</script>

<style scoped>
.nav-item {
  width: 680px;
  height: 36px;
  margin: 0px auto;
}
.nav-item ul {
  list-style: none;
  margin-left: 15px;
}
.nav-item li {
  float: left;
  font-size: 16px;
  font-weight: bold;

  margin-left: 30px;
}
.nav-item a {
  text-decoration: none;
  color: #555555;
}
.nav-item a:hover {
  color: #d9534f;
}
/*大的导航信息，包含导航，幻灯片等*/
.nav-body {
  width: 1020px;
  height: 485px;
  margin: 0px auto;
}
.nav-side {
  width: 200px;
  height: 100%;
  padding: 0px;
  color: #fff;
  float: left;
  background-color: #6e6568;
}
.nav-side ul {
  width: 100%;
  padding: 0px;
  padding-top: 15px;
  list-style: none;
}
.nav-side li {
  padding: 7.5px;
  padding-left: 15px;
  font-size: 15px;
  line-height: 25px;
}
.nav-side li:hover {
  background: #999395;
}
.nav-side-item:hover {
  cursor: pointer;
  color: #c81623;
}

/*导航内容*/
.nav-content {
  width: 792px;
  margin-left: 15px;
  overflow: hidden;
  float: left;
}
/*导航图片*/
.nav-show-img {
  margin-top: 10px;
  float: left;
}
.nav-show-img:nth-child(2) {
  margin-left: 12px;
}
/*显示商品*/
.content {
  width: 100%;
}
/*显示商品详细信息*/
.detail-item-panel {
  width: 815px;
  height: 485px;
  background-color: #fff;
  position: absolute;
  top: 168px;
  left: 389px;
  z-index: 999;
}
.nav-detail-item {
  margin-left: 26px;
  margin-top: 15px;
  margin-bottom: 15px;
  cursor: pointer;
  color: #eee;
}
.nav-detail-item span {
  padding: 6px;
  padding-left: 12px;
  margin-left: 15px;
  font-size: 12px;
  background-color: #6e6568;
}
.nav-detail-item span:hover {
  margin-left: 15px;
  background-color: #f44336;
}
.detail-item-panel ul {
  list-style: none;
}
.detail-item-panel li {
  line-height: 38px;
  margin-left: 40px;
}
.detail-item-title {
  padding-right: 6px;
  font-weight: bold;
  font-size: 12px;
  cursor: pointer;
  color: #555555;
}
.detail-item-title:hover {
  color: #d9534f;
}
.detail-item-row a {
  color: #555555;
}
.detail-item {
  font-size: 14px;
  padding-left: 12px;
  padding-right: 8px;
  cursor: pointer;
  border-left: 1px solid #ccc;
}
.detail-item:hover {
  color: #d9534f;
}
</style>



// WEBPACK FOOTER //
// src/components/nav/HomeNav.vue